import { type ObjectValuesUnionType } from '../../utils/typing';

export const BetBuilderActionTypes = Object.freeze({
  CLEAR_SELECTION: 'betbuilder/clearSelection',
  BASKET_UPDATE_BETBUILDER_ODD: 'betbuilder/basketUpdateBetbuilderOdd',
});

export type BetBuilderActionType = ObjectValuesUnionType<typeof BetBuilderActionTypes>;
